import { render, staticRenderFns } from "./AddCarriageTemplate.vue?vue&type=template&id=4e0b794e&scoped=true"
import script from "./AddCarriageTemplate.vue?vue&type=script&lang=js"
export * from "./AddCarriageTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddCarriageTemplate.vue?vue&type=style&index=0&id=4e0b794e&prod&lang=less&scoped=true"
import style1 from "./AddCarriageTemplate.vue?vue&type=style&index=1&id=4e0b794e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b794e",
  null
  
)

export default component.exports